import * as React from 'react';
import { Button, ModalWindow, Spinner, SpinnerSize } from 'ui-toolkit';

interface IPageWithOutsideLinks {
  outsideClick: boolean;
  pageContainsError: boolean;
  showUpdateSuccess: boolean;
  showUpdateSpinner: boolean;
  onUpdatePageClick: () => void;
}

const PageWithOutsideLinks: React.FunctionComponent<IPageWithOutsideLinks> = (props) => {
  const [showUpdateDataDialog, setShowUpdateDataDialog] = React.useState<boolean>(false);

  const toggleUpdateWindow = () => {
    setShowUpdateDataDialog(!showUpdateDataDialog);
  };

  React.useEffect(() => {
    setShowUpdateDataDialog(props.outsideClick);
  }, [props.outsideClick]);

  return (
    <div>
      {showUpdateDataDialog ? (
        <ModalWindow uitype={'small'} onClose={toggleUpdateWindow}>
          <h3>
            {props.pageContainsError
              ? 'There was a problem update the page. Do you want to try again?'
              : 'Do you want to update page?'}
          </h3>
          <div className={'save-dialog'}>
            {props.showUpdateSpinner ? <Spinner size={SpinnerSize.small} className={'save-dialog--icon'} /> : null}
            <Button intent="primary" id={'save-dialog-button'} onClick={props.onUpdatePageClick}>
              {props.pageContainsError ? 'Try again' : 'Yes'}
            </Button>
            <Button intent="secondary" className={'save-changes--button'} onClick={toggleUpdateWindow}>
              No
            </Button>
          </div>
        </ModalWindow>
      ) : null}
    </div>
  );
};

export default PageWithOutsideLinks;
